<template>
  <layout :title="pageTitle">
    <form @submit.prevent="submit">
      <section class="section">
        <div class="columns">
          <div class="column is-12">
            <div class="box">
              <a id="overview"></a>
              <h3>Overview</h3>
              <hr style="margin-top: 15px" />
              <div class="columns">
                <div class="column">
                  <b-field label="Project Group Name">
                    <b-input v-model="projectGroup.name"></b-input>
                  </b-field>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <b-field label="Client">
                    <b-select
                      v-if="clients.length > 0"
                      placeholder="Select a client"
                      expanded
                      v-model="projectGroup.client"
                      @input="clientSelected()"
                    >
                      <option
                        v-for="client in clients"
                        :value="client"
                        :key="client.id"
                      >
                        {{ client.name }}
                      </option>
                    </b-select>
                    <p v-else>
                      No clients available
                      <a :href="route('clients.create')">Create One Now</a>
                    </p>
                  </b-field>
                </div>
              </div>
              <div class="columns" v-if="projectGroup.client">
                <div class="column">
                  <b-field label="Question Set">
                    <b-select
                      v-if="
                        clientById[projectGroup.client.id].question_sets
                          .length > 0
                      "
                      placeholder="Select a question set"
                      expanded
                      v-model="projectGroup.question_set"
                      :disabled="
                        clientById[projectGroup.client.id].question_sets
                          .length == 1
                      "
                    >
                      <option
                        v-for="questionSet in clientById[projectGroup.client.id]
                          .question_sets"
                        :value="questionSet"
                        :key="questionSet.id"
                      >
                        {{ questionSet.name }}
                      </option>
                    </b-select>
                    <p v-else>
                      No question sets available
                      <a :href="route('question-sets.create')"
                        >Create One Now</a
                      >
                    </p>
                  </b-field>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <button
              type="submit"
              class="button is-primary"
              :disabled="isDisabled"
            >
              Add Project Group
            </button>
          </div>
        </div>
      </section>
    </form>
  </layout>
</template>

<script>
import Layout from './Layout';

export default {
  components: {
    Layout,
  },
  props: {
    projectGroup: { type: Object },
    clients: { type: Array },
  },
  data() {
    return {
      pageTitle: 'Add Project Group',
    };
  },
  computed: {
    clientById: function () {
      let clients = [];
      this.clients.forEach((client) => {
        clients[client.id] = client;
      });
      return clients;
    },
    isDisabled: function () {
      if (!this.projectGroup.client || !this.projectGroup.question_set) {
        return true;
      }
      return false;
    },
  },
  methods: {
    clientSelected: function () {
      if (this.clientById[this.projectGroup.client.id].question_sets.length < 1)
        return;

      var i = 0;
      do {
        this.projectGroup.question_set =
          this.clientById[this.projectGroup.client.id].question_sets[i];
        i++;
      } while (!this.projectGroup.question_set);
    },
    submit() {
      this.$inertia.post(route('project-groups.store'), this.projectGroup);
    },
  },
};
</script>
